import {
  FarmContainer,
  RightTitle,
  RightTitleText,
} from "./styled";
import { useContext, useEffect, useState } from "react";
import MyStake from "./MyStake";
import {
  ContentCaontainer,
  ContentRight,
  LiquidityDetailsWrapper,
} from "../Liquidity/Details/styled";
import Stake from "./NewStake";
import Finished from "./Finished";
import ModalClaim from "./Finished/ModalClaim";
import Gift from "../../assets/gif/staking.gif";
import Comming from "../../assets/gif/comming.gif";
import {
  ContextProviderWrapper,
  convertFixed,
  KeyvisualCommon,
  ModalOverlay,
} from "@kibble-exchange/uikit";
import close from "../../assets/Dashboard/Common/close.svg";
import leftyTears from "../../assets/img/leftytears.png";
import CountdownTimer from "./CountdownTimer";
import {
  FairBox,
  FairProgress,
  FairProgressBar,
  FairProgressCompare,
  FairProgressHeader,
  FairProgressPercent,
} from "../Launchpad/FAIR/styled";
import { getGlobalDataPresale, getUserDataPresale } from "store/features/presaleSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "store/store";
import { useTonAddress } from "@tonconnect/ui-react";
import MainSection from "./MainSection";
import "./MainSection.css";

const Presale = () => {
  const dispatch = useDispatch();
  const [rightSelected, setRightSelected] = useState(1);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [dataModal, setDataModal] = useState<any>();
  const { isMobile, theme }: any = useContext(ContextProviderWrapper);
  const { globalData, userdata } = useSelector((state: any) => state.presale);
  const address: any = useTonAddress();
  useEffect(() => {
    dispatch(getGlobalDataPresale());
    if (address) {
      dispatch(getUserDataPresale(address));
    }
  }, [dispatch, address]);

  const calcProgress = () => {
    return (Number(globalData.cap) - Number(globalData.total_supply)) / Number(globalData.cap);
  };
  return (
    <FarmContainer>
      <LiquidityDetailsWrapper className={theme}>
        {!isMobile ? (
          <div style={{ marginTop: "-80px" }}>
            <MainSection />
          </div>
        ) : (
          <div style={{ marginTop: "-20px" }}>
            <MainSection />
          </div>
        )}
        {/*<TitleBox>
          <img src={leftyTears} width="256px" alt="" className="mx-auto token-logo" />
          <h2 className="h2 text-center">LEFTYTEARS</h2>
        </TitleBox>*/}
        <div className="logos">
          <img src={leftyTears} alt="$LeftyTears" className="token-logo3" width="240px" />
          <p className="token-description">$LeftyTears</p>
        </div>
        <br />
        <div className="timer-text-box">
          {globalData?.end_date && <CountdownTimer targetDate={Number(globalData.end_date)} />}
          <div style={{ maxWidth: "520px", marginRight: "auto", marginLeft: "auto" }}>
            <FairBox>
              <FairProgress>
                <FairProgressHeader>
                  <p>Progress</p>
                  <p>
                    <span>{calcProgress() * 100}%</span>
                  </p>
                </FairProgressHeader>
                <FairProgressBar Progress={calcProgress() * 100}>
                  <span></span>
                </FairProgressBar>
                <FairProgressPercent>
                  <span>{globalData && globalData.cap - globalData.total_supply}</span>
                  <span> /{globalData && convertFixed(globalData?.cap ?? 0)}</span>
                </FairProgressPercent>
                <FairProgressCompare>
                  <p>
                    <span>1</span> LEFTYTEARS = <span>{(1 / globalData.price).toFixed(4)} TON</span>
                  </p>
                </FairProgressCompare>
              </FairProgress>
            </FairBox>
          </div>
        </div>
        <br />
        {/*{isMobile && (
          <KeyvisualCommon
            title="KIB Presale"
            description={"Earn rewards by providing liquidity"}
            image={isMobile ? Gift : <></>}
            buttonText="Buy now"
            buttonLink="#"
            buttonIcon={""}
          />
        )}*/}
        <ContentCaontainer>
          {/* ---------Box-left---------------- */}
          {/* <div className="content-left-main">
            <ContentLeft>
              <p className={`${theme} text-left`}>My summary</p>
              <TabsSelector
                data={TabsListLeft}
                callBack={(item: any) => {
                  setLeftSelected(item.value);
                }}
                active={leftSelected}
              />
              {leftSelected !== 1 ? (
                <Summary/>
              ) : (
                <KibTokent/>
              )}
            </ContentLeft>
            {!isMobile && (
              <BlockCommingSoon className={theme}>
                <BlockCommingLeft>
                  <img src={Comming} alt="" />
                </BlockCommingLeft>
                <BlockCommingRight>
                  <BlockCommingTextBig className={theme}>
                    Waiting for our amazing staking feature.
                  </BlockCommingTextBig>
                  <BlockCommingTextSmall>Coming soon</BlockCommingTextSmall>
                </BlockCommingRight>
              </BlockCommingSoon>
            )}
          </div> */}

          {/* ---------Box-Right---------------- */}
          <ContentRight>
            <RightTitle>
              {!isMobile && <RightTitleText className={theme}>Token Presale </RightTitleText>}
              {/* <div className="TabsBox" >
                {!isMobile && (
                  <TabsSelector
                    data={TabsListRight}
                    disabled
                    callBack={(item: any) => {
                      setRightSelected(item.value);
                    }}
                    active={rightSelected}
                  />
                )}
              </div> */}
            </RightTitle>
            {rightSelected === 1 && <Stake />}
            {rightSelected === 2 && (
              <MyStake setOpenConfirmModal={setOpenConfirmModal} setDataModal={setDataModal} />
            )}
            {rightSelected === 3 && <Finished />}
          </ContentRight>
          {/*{isMobile && (
            <BlockCommingSoon className={theme}>
              <BlockCommingLeft>
                <img src={Comming} alt="" />
              </BlockCommingLeft>
              <BlockCommingRight>
                <BlockCommingTextBig className={theme}>
                  Waiting for our amazing staking feature.
                </BlockCommingTextBig>
                <BlockCommingTextSmall>Coming soon</BlockCommingTextSmall>
              </BlockCommingRight>
            </BlockCommingSoon>
          )}
          {isMobile && (
            <TabsSelector
              data={TabsListRight}
              callBack={(item: any) => {
                setRightSelected(item.value);
              }}
              active={rightSelected}
            />
          )}*/}
        </ContentCaontainer>
      </LiquidityDetailsWrapper>
      <ModalOverlay
        component={<ModalClaim />}
        onClickParent={() => {
          setOpenConfirmModal(false);
        }}
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        title={"claim rewards"}
        width="500px"
        closeIcon={close}
      />
    </FarmContainer>
  );
};

export default Presale;
